export enum I18nKeys {
  AdditionalOptionZeroQuantity = 'additional-option-zero-quantity',
  AddressNotFoundError = 'address-not-found-error',
  AddRemoveSectionLabel = 'add-remove-section-label',
  AddSurfaceComponentDialogAddAccessories = 'add-surface-component-dialog-add-accessories',
  AddSurfaceComponentDialogAccessories = 'add-surface-component-dialog-accessories',
  AddSurfaceComponentDialogSections = 'add-surface-component-dialog-sections',
  AddSurfaceComponentDialogCupola = 'add-surface-component-dialog-cupola',
  AddSurfaceComponentDialogCupolaQuantity = 'add-surface-component-dialog-cupola-quantity',
  AddSurfaceComponentDialogRoofSnoop = 'add-surface-component-dialog-roof-snoop',
  AdyenPaymentDialogTitle = 'adyen-payment-dialog-title',
  AdyenPaymentCancelledError = 'adyen-payment-cancelled-error',
  AdyenPaymentErrorError = 'adyen-payment-error-error',
  AdyenPaymentNotSupporteError = 'adyen-payment-not-supported-error',
  AdyenPaymentRefusedError = 'adyen-payment-refused-error',
  ARDialogLoadingMessage = 'ar-dialog-loading-message',
  ARDialogErrorMessage = 'ar-dialog-error-message',
  ARDialogReadyMessage = 'ar-dialog-ready-message',
  ARDialogOpenOnSupportedDevice = 'ar-dialog-open-on-supported-device',
  ARDialogViewInARButton = 'ar-dialog-view-in-ar-button',
  ARDialogOr = 'ar-dialog-or',
  ARDialogPhoneEmail = 'ar-dialog-phone-email',
  ARDialogSendLink = 'ar-dialog-send-link',
  ARDialogLinkSuccess = 'ar-dialog-link-success',
  ARDialogLinkErrorPhone = 'ar-dialog-link-error-phone',
  ARDialogLinkErrorEmail = 'ar-dialog-link-error-email',
  ARDialogLinkErrorUnavailable = 'ar-dialog-link-service-unavailable',
  ARDialogRetryIn = 'ar-dialog-retry-in',
  ARDialogSMSMessage = 'ar-dialog-sms-message',
  ARDialogSupportedAppleDevices = 'ar-dialog-supported-apple-devices',
  ARDialogSupportedAndroidDevices = 'ar-dialog-supported-android-devices',
  ARDialogNotSupported = 'ar-dialog-not-supported',
  ARWebXRMovePhone = 'ar-webxr-move-phone',
  ARWebXRControlInstructions = 'ar-webxr-control-instructions',
  AutoSaveDesignDialogMessage = 'auto-save-design-dialog-message',
  AutoSaveDesignDialogTitle = 'auto-save-design-dialog-title',
  AutoSaveDesignDialogCancelButton = 'auto-save-design-dialog-cancel-button',
  AutoSaveDesignDialogRestoreButton = 'auto-save-design-dialog-restore-button',
  BackSide = 'back-side',
  BillingAddressCheckboxLabel = 'billing-address-radio-label',
  BuildingSaveDetails = 'building-save-details',
  CancelBtn = 'cancel-btn',
  CapBuildingSize = 'cap-building-size',
  CapCenterItemsButton = 'cap-center-items-button',
  CapClearItemsButton = 'cap-clear-items-button',
  CapMenuHeaderEnterZipCodeForEstimate = 'cap-menu-header-enter-zip-code-for-estimate',
  CapMenuHeaderEstimatedPriceForLocation = 'cap-menu-header-estimated-price-for-location',
  CapMenuHeaderPriceFormat = 'cap-menu-header-price-format',
  CapMenuHeaderNoPricingForLocation = 'cap-menu-header-no-pricing-for-location',
  CapMenuHeaderSaveButton = 'cap-menu-header-save-button',
  CapMenuHeaderStyleLabel = 'cap-menu-header-style-label',
  CapMenuHeaderSelectStateForEstimate = 'cap-menu-header-select-state-for-estimate',
  CapMenuYourDetailsTitle = 'cap-menu-your-details-title',
  CapMenuYourEstimateTitle = 'cap-menu-your-estimate-title',
  CapSaveDialogTitle = 'cap-save-dialog-title',
  CapSaveDialogSMSMessage = 'cap-save-dialog-sms-message',
  CapSaveEmailField = 'cap-save-email-field',
  CapSaveMobilePhoneField = 'cap-save-mobile-phone-field',
  CapSaveSendTextField = 'cap-save-send-text-field',
  CapSaveFirstNameField = 'cap-save-first-name-field',
  CapSaveLastNameField = 'cap-save-last-name-field',
  ChangeSupplierDialogMessage = 'change-supplier-dialog-msg',
  CheckoutBtn = 'checkout-btn',
  CheckoutDialogError = 'checkout-dialog-error',
  CheckoutDialogFinancingTitle = 'checkout-dialog-financing-title',
  CheckoutDialogRtoTotalCostOfLeaseServices = 'checkout-dialog-rto-total-cost-of-lease-services',
  CheckoutDialogRtoTitle = 'checkout-dialog-rto-title',
  CheckoutDialogStepTwoTitle = 'checkout-dialog-step-two-title',
  ClearAll = 'clear-all',
  Clone = 'clone',
  Close = 'close',
  CognitoSignInText = 'cognito-sign-in-text',
  CognitoSignInUsername = 'cognito-sign-in-username',
  CognitoSignInPassword = 'cognito-sign-in-password',
  CognitoSignInForgotPassword = 'cognito-sign-in-forgot-password',
  CognitoSignInButton = 'cognito-sign-in-button',
  CognitoForgotPasswordText = 'cognito-forgot-password-text',
  CognitoForgotPasswordUsername = 'cognito-forgot-password-username',
  CognitoForgotPasswordAlready = 'cognito-forgot-password-already',
  CognitoForgotPasswordSignIn = 'cognito-forgot-password-sign-in',
  CognitoForgotPasswordButton = 'cognito-forgot-password-button',
  CognitoResetPasswordText = 'cognito-reset-password-text',
  CognitoResetPasswordVerificationCode = 'cognito-reset-password-verification-code',
  CognitoResetPasswordNewCode = 'cognito-reset-password-new-code',
  CognitoResetPasswordPassword = 'cognito-reset-password-password',
  CognitoResetPasswordConfirmPassword = 'cognito-reset-password-confirm-password',
  CognitoResetPasswordButton = 'cognito-reset-password-button',
  CognitoRequireNewPasswordText = 'cognito-require-new-password-text',
  CognitoRequireNewPasswordFirstName = 'cognito-require-new-password-first-name',
  CognitoRequireNewPasswordLastName = 'cognito-require-new-password-last-name',
  CognitoRequireNewPasswordPassword = 'cognito-require-new-password-password',
  CognitoRequireNewPasswordConfirmPassword = 'cognito-require-new-password-confirm-password',
  CognitoRequireNewPasswordButton = 'cognito-require-new-password-button',
  ColorSelectorCustomColor = 'color-selector-custom-color',
  ColorSelectorSelectedColor = 'color-selector-selected-color',
  ColorsOtherSubgroupLabel = 'colors-other-subgroup-label',
  ComponentAddonMenuAddRamp = 'component-addon-menu-add-ramp',
  ComponentAddonMenuAddShutters = 'component-addon-menu-add-shutters',
  ComponentAddonMenuCustomize = 'component-addon-menu-customize',
  ComponentCardBracket = 'component-card-bracket',
  ComponentCardCornerStyle = 'component-card-corner-style',
  ComponentCardDoorHandle = 'component-card-door-handle',
  ComponentCardFlowerBox = 'component-card-flower-box',
  ComponentCardHeight = 'component-card-height',
  ComponentCardHinge = 'component-card-hinge',
  ComponentCardHingeLocation = 'component-card-hinge-location',
  ComponentCardRoofPitch = 'component-card-roof-pitch',
  ComponentCardShutters = 'component-card-shutters',
  ComponentCardWidth = 'component-card-width',
  ComponentPropertyMenuOptions = 'component-property-menu-options',
  ComponentSelectorNoComponentsMessage = 'component-selector-no-components-message',
  ComponentWarningMessage = 'component-dialog-warning-message',
  ContactBarText = 'contact-bar-text',
  ContactBarTextWithoutEmail = 'contact-bar-text-without-email',
  ContinueButton = 'continue-btn',
  ConsolidatedDetailsStyleAndSize = 'consolidated-details-style-and-size',
  ConsolidatedDetailsColorsAndMaterials = 'consolidated-details-color-and-materials',
  ConsolidatedDetailsSidesAndEnds = 'consolidated-details-sides-and-ends',
  ConsolidatedDetailsCenterSection = 'consolidated-details-center-section',
  ConsolidatedDetailsLeftSection = 'consolidated-details-left-section',
  ConsolidatedDetailsRightSection = 'consolidated-details-right-section',
  ConsolidatedDetailsFrontSection = 'consolidated-details-front-section',
  ConsolidatedDetailsBackSection = 'consolidated-details-back-section',
  ConsolidatedDetailsDoorsAndWindows = 'consolidated-details-doors-and-windows',
  ConsolidatedDetailsFlooringAndInterior = 'consolidated-details-flooring-and-interior',
  ConsolidatedDetailsAdditionalOptions = 'consolidated-details-additional-options',
  ConsolidatedDetailsAdditionalFees = 'consolidated-details-additional-fees',
  ConsolidatedDetailsAdditionalInformation = 'consolidated-details-additional-information',
  ConsolidatedDetailsUnknown = 'consolidated-details-unknown',
  ConsolidatedInvoiceStyleAndSize = 'consolidated-invoice-style-and-size',
  ConsolidatedInvoiceColorsAndMaterials = 'consolidated-invoice-color-and-materials',
  ConsolidatedInvoiceSidesAndEnds = 'consolidated-invoice-sides-and-ends',
  ConsolidatedInvoiceCenterSection = 'consolidated-invoice-center-section',
  ConsolidatedInvoiceLeftSection = 'consolidated-invoice-left-section',
  ConsolidatedInvoiceRightSection = 'consolidated-invoice-right-section',
  ConsolidatedInvoiceFrontSection = 'consolidated-invoice-front-section',
  ConsolidatedInvoiceBackSection = 'consolidated-invoice-back-section',
  ConsolidatedInvoiceDoorsAndWindows = 'consolidated-invoice-doors-and-windows',
  ConsolidatedInvoiceFlooringAndInterior = 'consolidated-invoice-flooring-and-interior',
  ConsolidatedInvoiceAdditionalOptions = 'consolidated-invoice-additional-options',
  ConsolidatedInvoiceAdditionalFees = 'consolidated-invoice-additional-fees',
  ConsolidatedInvoiceUnknown = 'consolidated-invoice-unknown',
  CustomLineItemDescription = 'custom-line-item-description',
  CustomizeBuilding = 'customize-building',
  CustomizeBuildingCenterSectionSize = 'customize-building-dialog-center-section-size',
  CustomizeBuildingLeanSize = 'customize-building-lean-size',
  CustomizeBuildingBuildingColors = 'customize-building-dialog-building-colors',
  CustomMenuSkylightOptionsLeftSide = 'custom-menu-skylight-options-left-side',
  CustomMenuSkylightOptionsRightSide = 'custom-menu-skylight-options-right-side',
  CupolaPropertyMenuFinishing = 'cupola-property-menu-finishing',
  CupolaPropertyMenuOptions = 'cupola-property-menu-options',
  CupolaPropertyMenuRoofStyle = 'cupola-property-menu-roof-style',
  CupolaPropertyMenuSiding = 'cupola-property-menu-siding',
  CupolaPropertyMenuTitle = 'cupola-property-menu-title',
  CupolaPropertyMenuWeathervane = 'cupola-property-menu-weathervane',
  DeliveryMessage = 'delivery-message',
  DetailsAnchorPackage = 'details-anchor-package',
  DetailsBackSection = 'details-back-section',
  DetailsBackWall = 'details-back-wall',
  DetailsBuyNowBtn = 'buy-now-btn',
  DetailsCardDetailsBtn = 'details-card-details-btn',
  DetailsCardTitleDetailsStateRequired = 'details-card-title-details-state-required',
  DetailsCardTitleDetailsZipRequired = 'details-card-title-details-zip-required',
  DetailsCardTitleEstimate = 'details-card-title-estimate',
  DetailsCardTitleEstimateForLocation = 'details-card-title-estimate-for-location',
  DetailsCardTitleEstimateStateRequired = 'details-card-title-estimate-state-required',
  DetailsCardTitleEstimateZipRequired = 'details-card-title-estimate-zip-required',
  DetailsCardTitleNoRegionPricing = 'details-card-title-no-region-pricing',
  DetailsCardTitleNoPricing = 'details-card-title-no-pricing',
  DetailsCardTitleYourState = 'details-card-title-your-state',
  DetailsCardTitleYourZip = 'details-card-title-your-zip',
  DetailsCategoryAdditionalFees = 'details-category-additional-fees',
  DetailsCategoryAdditionalInformation = 'details-category-additional-information',
  DetailsCategoryAdditionalOption = 'details-category-additional-option',
  DetailsCategoryAdditionsAndAdjustments = 'details-category-additions-and-adjustments',
  DetailsCategoryDoors = 'details-category-doors',
  DetailsCategoryFlooringInterior = 'details-category-flooring-interior',
  DetailsCategoryFrameouts = 'details-category-frameouts',
  DetailsCategoryGarageDoors = 'details-category-garage-doors',
  DetailsCategoryRollUpDoors = 'details-category-roll-up-doors',
  DetailsCategoryStructure = 'details-category-structure',
  DetailsCategoryVents = 'details-category-vents',
  DetailsCategoryWindows = 'details-category-windows',
  DetailsCenterSection = 'details-center-section',
  DetailsCreditCardFee = 'details-credit-card-fee-v2',
  DetailsCompletePurchaseBtn = 'complete-purchase-btn',
  DetailsDelivery = 'details-delivery-v2',
  DetailsDeposit = 'details-deposit',
  DetailsDepositDiscounts = 'details-deposit-discounts',
  DetailsProcessingFee = 'details-processing-fee',
  DetailsDepositDueNow = 'details-deposit-due-now',
  DetailsDeliveryFeeSubtotal = 'details-delivery-fee-subtotal-v2',
  DetailsDepositDueUponDelivery = 'details-deposit-due-upon-delivery',
  DetailsDepositWithPercentage = 'details-deposit-with-percentage',
  DetailsEstimateCsvFilename = 'details-estimate-csv-filename',
  DetailsFrontSection = 'details-front-section',
  DetailsFrontWall = 'details-front-wall',
  DetailsGlobalSection = 'details-global-section',
  DetailsItemDripEdgeColor = 'details-item-drip-edge-color',
  DetailsItemDripEdgeCustomColor = 'details-item-drip-edge-custom-color',
  DetailsItemFloorJoist = 'details-item-floor-joist',
  DetailsItemFlooring = 'details-item-flooring',
  DetailsItemInteriorRoof = 'details-item-interior-roof',
  DetailsItemInteriorWall = 'details-item-interior-wall',
  DetailsItemLoft = 'details-item-loft',
  DetailsItemPorch = 'details-item-porch',
  DetailsItemPorchColumn = 'details-item-porch-column',
  DetailsItemPorchDepth = 'details-item-porch-depth',
  DetailsItemPorchLength = 'details-item-porch-length',
  DetailsItemPorchRailing = 'details-item-porch-railing',
  DetailsItemShelving = 'details-item-shelving',
  DetailsItemWorkbenches = 'details-item-workbenches',
  DetailsItemWallColor = 'details-item-wall-color',
  DetailsItemWallLength = 'details-item-wall-length',
  DetailsItemShuttersColor = 'details-item-shutters-color',
  DetailsItemShuttersCustomColor = 'details-item-shutters-custom-color',
  DetailsItemSidingColor = 'details-item-siding-color',
  DetailsItemSidingCustomColor = 'details-item-siding-custom-color',
  DetailsItemRoofColor = 'details-item-roof-color',
  DetailsItemRoofCustomColor = 'details-item-roof-custom-color',
  DetailsItemRoofSheetingColor = 'details-item-roof-sheeting-color',
  DetailsItemRoofSheetingCustomColor = 'details-item-roof-sheeting-custom-color',
  DetailsItemCredit = 'details-item-credit',
  DetailsItemFlowerBox = 'details-item-flower-box',
  DetailsItemFlowerBoxColor = 'details-item-flower-box-color',
  DetailsItemFlowerBoxCustomColor = 'details-item-flower-box-custom-color',
  DetailsItemBase = 'details-item-base',
  DetailsItemBasePrice = 'details-item-base-price',
  DetailsItemBasePriceLabel = 'details-item-base-price-label',
  DetailsItemBasePriceLength = 'details-item-base-price-length',
  DetailsItemBrace = 'details-item-brace',
  DetailsItemBracket = 'details-item-bracket',
  DetailsItemBuildingLayout = 'details-item-building-layout',
  DetailsItemColor = 'details-item-color',
  DetailsItemCustomColor = 'details-item-custom-color',
  DetailsItemComponentSpecificAdditionalOption = 'details-item-component-specific-additional-option',
  DetailsItemComponentWithCustomSize = 'details-item-component-with-custom-size',
  DetailsItemCornerStyle = 'details-item-corner-style',
  DetailsItemCupola = 'details-item-cupola',
  DetailsItemCupolaFinishing = 'details-item-cupola-finishing',
  DetailsItemCupolaRoofing = 'details-item-cupola-roofing',
  DetailsItemCupolaSiding = 'details-item-cupola-siding',
  DetailsItemCupolaSidingColor = 'details-item-cupola-siding-color',
  DetailsItemCutFee = 'details-item-cut-fee',
  DetailsItemDoorHandle = 'details-item-door-handle',
  DetailsItemEndWalls = 'details-item-end-walls',
  DetailsItemEngineerCertified = 'details-item-engineer-certified',
  DetailsItemExtraPanel = 'details-item-extra-panel',
  DetailsItemFrameSpacing = 'details-item-frame-spacing',
  DetailsItemGableSiding = 'details-item-gable-siding',
  DetailsItemGauge = 'details-item-gauge',
  DetailsItemHeight = 'details-item-height',
  DetailsItemHinges = 'details-item-hinges',
  DetailsItemInsulation = 'details-item-insulation',
  DetailsitemInsulationMaterial = 'details-item-insulation-material',
  DetailsItemJTrim = 'details-item-j-trim',
  DetailsItemJTrimWithPrefix = 'details-item-j-trim-with-prefix',
  DetailsItemLeanType = 'details-item-lean-type',
  DetailsItemLeg = 'details-item-leg',
  DetailsItemLength = 'details-item-length',
  DetailsItemPackage = 'details-item-package',
  DetailsItemPorchDeckingColor = 'details-item-porch-decking-color',
  DetailsItemPorchDeckingCustomColor = 'details-items-porch-decking-custom-color',
  DetailsItemPorchRailingColor = 'details-item-porch-railing-color',
  DetailsItemPorchRailingCustomColor = 'details-item-porch-railing-custom-color',
  DetailsItemPorchColumnColor = 'details-item-porch-column-color',
  DetailsItemPorchColumnCustomColor = 'details-item-porch-column-custom-color',
  DetailsItemRainGutter = 'details-item-rain-gutter',
  DetailsItemRoof = 'details-item-roof',
  DetailsItemRoofExtension = 'details-item-roof-extension',
  DetailsItemRoofing = 'details-item-roofing',
  DetailsItemRoofMaterial = 'details-item-roof-material',
  DetailsItemRoofOverhang = 'details-item-roof-overhang',
  DetailsItemRoofPitch = 'details-item-roof-pitch',
  DetailsItemRoofSnoop = 'details-item-roof-snoop',
  DetailsItemSideWalls = 'details-item-side-walls',
  DetailsItemSiding = 'details-item-siding',
  DetailsItemSnowLoad = 'details-item-snow-load',
  DetailsItemStoragePrefix = 'details-item-storage-prefix',
  DetailsItemStyle = 'details-item-style',
  DetailsItemTrim = 'details-item-trim',
  DetailsItemTrusses = 'details-item-trusses',
  DetailsItemWainscot = 'details-item-wainscot',
  DetailsItemWainscotWithColor = 'details-item-wainscot-with-color',
  DetailsItemWainscotWithColorAndPrefix = 'details-item-wainscot-with-color-and-prefix',
  DetailsItemWainscotWithColorGroup = 'details-item-wainscot-with-color-group',
  DetailsItemWainscotWithColorGroupAndPrefix = 'details-item-wainscot-with-color-group-and-prefix',
  DetailsItemWall = 'details-item-wall',
  DetailsItemWeathervane = 'details-item-weathervane',
  DetailsItemWidth = 'details-item-width',
  DetailsItemInstallationSurface = 'details-item-installation-surface',
  DetailsLeftSection = 'details-left-section',
  DetailsLeftWall = 'details-left-wall',
  DetailsNonTaxableServices = 'details-non-taxable-services-v2',
  DetailsTaxableServices = 'details-taxable-services',
  DetailsRightSection = 'details-right-section',
  DetailsRightWall = 'details-right-wall',
  DetailsSalesTax = 'details-sales-tax',
  DetailsSalesTaxExempt = 'details-sales-tax-exempt',
  DetailsSalesTaxUndefined = 'details-sales-tax-undefined',
  DetailsSalesTaxTotalVat = 'details-sales-tax-total-vat',
  DetailsStateRequired = 'details-state-required',
  DetailsStateRequiredForEstimate = 'details-state-required-for-estimate',
  DetailsSubtotal = 'details-subtotal-v2',
  DetailsSubtotalForNoDeliveryReturned = 'details-delivery-v2-for-no-delivery-returned',
  DetailsTotal = 'details-total',
  DetailsTotalForNoDeliveryReturned = 'details-total-for-no-delivery-returned',
  DetailsWindBracing = 'details-wind-bracing',
  DetailsZipRequired = 'details-zip-required',
  DetailsZipRequiredForEstimate = 'details-zip-required-for-estimate',
  DigitalSignatureQuoteOnlySecondaryLabel = 'digital-signature-quote-only-secondary-label',
  DigitalSignatureEmailSecondaryLabel = 'digital-signature-email-secondary-label',
  DigitalSignatureBrowserSecondaryLabel = 'digital-signature-browser-secondary-label',
  DigitalSignatureBrowserPendingDialogFirst = 'digital-signature-browser-pending-dialog-first',
  DigitalSignatureBrowserPendingDialogSecond = 'digital-signature-browser-pending-dialog-second',
  DigitalSignatureBrowserPendingDialogThird = 'digital-signature-browser-pending-dialog-third',
  DigitalSignatureBrowserErrorMessage = 'digital-signature-browser-error-message',
  DropDownOptionListMultipleOptions = 'dropdown-option-list-multiple-options',
  Edit = 'edit',
  ElevationMapTitle = 'elevation-map-title',
  ElevationMapDisclaimerTitle = 'elevation-map-disclaimer-title',
  ElevationMapDisclaimerBody = 'elevation-map-disclaimer-body',
  EmailDeliveryLocation = 'email-delivery-location',
  EmailDialogError = 'email-dialog-error',
  EmailDialogPrintSubmiting = 'email-dialog-print-submiting',
  EmailDialogPrintSubmit = 'email-dialog-print-submit',
  EmailDialogPrintSupplierSubmiting = 'email-dialog-print-supplier-submiting',
  EmailDialogPrintSupplierSubmit = 'email-dialog-print-supplier-submit',
  EmailDialogSubmit = 'email-dialog-submit',
  EmailDialogSubmiting = 'email-dialog-submiting',
  EmailExternalSiteLinkSubmit = 'email-external-site-link-submit',
  EmailExternalSiteLinkSubmiting = 'email-external-site-link-submiting',
  EmailPricingTableLine = 'email-pricing-table-line',
  EmailRtoTotalCostOfLeaseServices = 'email-rto-total-cost-of-lease-services',
  FloorPlanDisclaimerMessage = 'floorplan-disclaimer-message',
  FloorPlanTitle = 'floorplan-title',
  FloorPlanSymbolLegend = 'floorplan-symbols-legend',
  FloorPlanSymbolLegendContinued = 'floorplan-symbols-legend-continued',
  FloorplanWallClosed = 'floorplan-wall-closed',
  FloorplanWallOpen = 'floorplan-wall-open',
  FloorplanBackSide = 'floorplan-back-side',
  FloorplanFrontSide = 'floorplan-front-side',
  FloorplanLeftSide = 'floorplan-left-side',
  FloorplanRightSide = 'floorplan-right-side',
  FooterLogoMessage = 'footer-logo-message',
  FrontSide = 'front-side',
  GeocodioServerError = 'geocodio-server-error',
  GeolocationApiNotAvailableError = 'geolocation-api-not-available-error',
  GoToLink = 'go-to-link',
  InstallationMessage = 'installation-message',
  InvalidEmailError = 'invalid-email-error',
  InvalidZipForStateError = 'invalid-zip-for-state-error',
  InvalidPhoneError = 'invalid-phone-error',
  InvoiceAdditionalFees = 'invoice-additional-fees',
  InvoiceAdditionalOptions = 'invoice-additional-options',
  InvoiceAdditionsAndAdjustments = 'invoice-additions-and-adjustments',
  InvoiceBlockAddressTitle = 'invoice-block-address-title',
  InvoiceBlockBillingAddress = 'invoice-block-billing-address',
  InvoiceBlockBillingCity = 'invoice-block-billing-city',
  InvoiceBlockBillingState = 'invoice-block-billing-state',
  InvoiceBlockBillingZipCode = 'invoice-block-billing-zip-code',
  InvoiceBlockCustomerName = 'invoice-block-customer-name',
  InvoiceBlockCustomerOrderNumber = 'invoice-block-customer-order-number',
  InvoiceBlockCustomerAddress = 'invoice-block-customer-address',
  InvoiceBlockCustomerCity = 'invoice-block-customer-city',
  InvoiceBlockCustomerCityStateZipCode = 'invoice-block-customer-city-state-zip-code',
  InvoiceBlockCustomerCityZipCode = 'invoice-block-customer-city-zip-code',
  InvoiceBlockCustomerState = 'invoice-block-customer-state',
  InvoiceBlockCustomerZipCode = 'invoice-block-customer-zip-code',
  InvoiceBlockCustomerEmail = 'invoice-block-customer-email',
  InvoiceBlockCustomerPhoneNumber = 'invoice-block-customer-phone-number',
  InvoiceBlockCustomerMobileNumber = 'invoice-block-customer-mobile-number',
  InvoiceBlockBuildingInfoTitle = 'invoice-block-building-info-title',
  InvoiceBlockColorTitle = 'invoice-block-color-title',
  InvoiceBlockDealerPhoneNumber = 'invoice-block-dealer-phone-number',
  InvoiceBlockDealerTitle = 'invoice-block-dealer-title',
  InvoiceBlockDesignLinkAndNotesTitle = 'invoice-block-design-link-and-notes-title',
  InvoiceBlockInstallationTitle = 'invoice-block-installation-title',
  InvoiceBlockSizeHeight = 'invoice-block-size-height',
  InvoiceBlockSizeLength = 'invoice-block-size-length',
  InvoiceBlockSizeWidth = 'invoice-block-size-width',
  InvoiceBlockSizeTitle = 'invoice-block-size-title',
  InvoiceCalculationProcessingFee = 'invoice-processing-fee',
  InvoiceCalculationSubtotal = 'invoice-subtotal',
  InvoiceCalculationTaxableServices = 'invoice-taxable-services',
  InvoiceCalculationNonTaxableServices = 'invoice-non-taxable-services',
  InvoiceCalculationSalesTaxVat = 'invoice-sales-tax-vat-v2',
  InvoiceCalculationSalesTax = 'invoice-sales-tax-v2',
  InvoiceCalculationSalesTaxExemptLabel = 'invoice-sales-tax-exempt-label',
  InvoiceCalculationSalesTaxVatExemptLabel = 'invoice-sales-tax-vat-exempt-label',
  InvoiceCalculationSalesTaxExempt = 'invoice-exempt',
  InvoiceCalculationNoSalesTax = 'invoice-no-sales-tax',
  InvoiceCalculationCreditCardFee = 'invoice-credit-card-fee',
  InvoiceCalculationDelivery = 'invoice-delivery',
  InvoiceCalculationTotalOrderAmount = 'invoice-total-order-amount',
  InvoiceCalculationDepositPaid = 'invoice-deposit-paid',
  InvoiceCalculationDepositToOrder = 'invoice-deposit-to-order',
  InvoiceCalculationDepositDiscount = 'invoice-deposit-discount',
  InvoiceCalculationDeliveryFeeSubtotal = 'invoice-delivery-fee-subtotal',
  InvoiceCalculationRemainingDue = 'invoice-remaining-due',
  InvoiceDesignLink = 'invoice-design-link',
  InvoiceDoors = 'invoice-doors',
  InvoiceFlooringInterior = 'invoice-flooring-interior',
  InvoiceFooterText = 'invoice-footer-text',
  InvoiceFrameouts = 'invoice-frameouts',
  InvoiceGarageDoors = 'invoice-garage-doors',
  InvoiceHeaderOrderDate = 'invoice-header-order-date',
  InvoiceHeaderSalesRep = 'invoice-header-sales-rep',
  InvoiceImageBack = 'invoice-image-back',
  InvoiceImageFloorplan = 'invoice-image-floorplan',
  InvoiceImageFront = 'invoice-image-front',
  InvoiceImageLeft = 'invoice-image-left',
  InvoiceImagePerspective = 'invoice-image-perspective',
  InvoiceImagePerspectiveInterior = 'invoice-image-perspective-interior',
  InvoiceImagePerspectiveBack = 'invoice-image-perspective-back',
  InvoiceImagePerspectiveBackInterior = 'invoice-image-perspective-back-interior',
  InvoiceImageRight = 'invoice-image-right',
  InvoiceQrCodeTitle = 'invoice-qr-code-title',
  InvoiceRightLeftLean = 'invoice-right-left-lean',
  InvoiceRollUpDoors = 'invoice-roll-up-doors',
  InvoiceStructureDetails = 'invoice-structure-details',
  InvoiceVents = 'invoice-vents',
  InvoiceWindows = 'invoice-windows',
  LabelHomeLinkUrl = 'label-home-link-url',
  LanguagesDialogTitle = 'languages-dialog-title',
  LanguagesDialogMessage = 'languages-dialog-message',
  LanguagesDialogState = 'languages-dialog-state',
  LeadDialogLeadEmail = 'lead-dialog-lead-email',
  LeadDialogLeadPhone = 'lead-dialog-lead-phone',
  LeadDialogLeadName = 'lead-dialog-lead-name',
  LeadDialogLeadZipCode = 'lead-dialog-lead-zip-code',
  LeadsDialogDefaultTitle = 'leads-dialog-default-title',
  LeadsDialogDefaultMessage = 'leads-dialog-default-message',
  LeadsDialogDefaultCallToActionText = 'leads-dialog-default-call-to-action-text',
  LeftSide = 'left-side',
  LocationDialogState = 'location-dialog-state',
  LocationDialogLeadEmail = 'location-dialog-lead-email',
  LocationDialogStateMsg = 'location-dialog-state-msg',
  LocationDialogStateEmailMsg = 'location-dialog-state-email-msg',
  LocationDialogTermsAndConditions = 'location-dialog-terms-and-conditions',
  LocationDialogZip = 'location-dialog-zip',
  LocationDialogZipMsg = 'location-dialog-zip-msg',
  LocationDialogZipEmailMsg = 'location-dialog-zip-email-msg',
  LoadBuildingFromAutoSaveNoAutoSave = 'load-building-from-auto-save-no-auto-save',
  LoadBuildingDialogTitle = 'load-building-dialog-title',
  LoadBuildingDialogOpen = 'load-building-dialog-open',
  LoadBuildingDialogInvalidEmailId = 'load-building-dialog-invalid-email-id',
  LoadBuildingDialogIntroText = 'load-building-dialog-intro-text',
  LoadBuildingDialogEmailIdPlaceholder = 'load-building-dialog-email-id-placeholder',
  LoadBuildingDialogBuildingNotFound = 'load-building-dialog-building-not-found',
  LoadBuildingDialogNotSupportedStyle = 'load-building-dialog-not-supported-style',
  LoadBuildingDialogSupplierNotAvailable = 'load-building-dialog-supplier-not-available',
  LogoBarBetaToggleOn = 'logo-bar-beta-toggle-on',
  LogoBarBetaToggleOff = 'logo-bar-beta-toggle-off',
  LogoBarChangeLocation = 'logo-bar-change-location',
  LogoBarCheckout = 'logo-bar-checkout',
  LogoBarDetails = 'logo-bar-details',
  LogoBarDownloadCustomPdf = 'logo-bar-download-custom-pdf',
  LogoBarSupplierDownloadCustomPdf = 'logo-bar-supplier-download-custom-pdf',
  LogoBarEmail = 'logo-bar-email',
  LogoBarInteriorToggle = 'logo-bar-interior-toggle',
  LogoBarLoadBuilding = 'logo-bar-load-building',
  LogoBarPrint = 'logo-bar-print',
  LogoBarQuote = 'logo-bar-quote',
  LogoBarSales = 'logo-bar-sales',
  LogoBarSavedBuildings = 'logo-bar-saved-buildings',
  LogoBarSceneEnvironment = 'logo-bar-scene-environment',
  LogoBarShare = 'logo-bar-share',
  LogoBarSupplierPrint = 'logo-bar-supplier-print',
  LogoBarTutorial = 'logo-bar-tutorial',
  MenuCenterSectionWindBracing = 'menu-center-section-wind-bracing',
  MenuColorsIntroText = 'menu-colors-intro-text',
  MenuColorsTitle = 'menu-colors-title',
  MenuDoorsWindowsAddItemsToRoof = 'menu-doors-windows-add-items-to-roof',
  MenuDoorsWindowsAddItemsToWall = 'menu-doors-windows-add-items-to-wall',
  MenuDoorsWindowsAdditionalOptions = 'menu-doors-windows-additional-options',
  MenuDoorsWindowsBuildingLayoutIntroText = 'menu-doors-windows-building-layout-intro-text',
  MenuDoorsWindowsBuildingLayoutBuildingText = 'menu-doors-windows-building-layout-selected-text',
  MenuDoorsWindowsCustomLayoutAddPackageItems = 'menu-doors-windows-custom-layout-add-package-items',
  MenuDoorsWindowsCustomLayoutIntroText = 'menu-doors-windows-custom-layout-intro-text',
  MenuDoorsWindowsCustomLayoutTabTitle = 'menu-doors-windows-custom-layout-tab-title',
  MenuDoorsWindowsCupola = 'menu-doors-windows-cupola',
  MenuDoorsWindowsCupolaQuantity = 'menu-doors-windows-cupola-quantity',
  MenuDoorsWindowsEndText = 'menu-doors-windows-end-text',
  MenuDoorsWindowsIntroText = 'menu-doors-windows-intro-text',
  MenuDoorsWindowsStandardLayoutTabTitle = 'menu-doors-windows-standard-layout-tab-title',
  MenuDoorsWindowsTitle = 'menu-doors-windows-title',
  MenuFlooringInteriorFrameSpacing = 'menu-flooring-interior-frame-spacing',
  MenuFlooringInteriorFrameSpacingPerSection = 'menu-flooring-interior-frame-spacing-per-section',
  MenuFlooringTitle = 'menu-flooring-title',
  MenuInteriorTitle = 'menu-interior-title',
  MenuInteriorIntroText = 'menu-interior-intro-text',
  MenuMaterialsIntroText = 'menu-materials-intro-text',
  MenuMaterialsTitle = 'menu-materials-title',
  MenuInteriorCustomLayoutAddPackageItems = 'menu-interior-custom-layout-add-package-items',
  MenuInteriorCustomLayoutIntroText = 'menu-interior-custom-layout-intro-text',
  MenuMobileEdit = 'menu-mobile-edit',
  MenuMorePackagesTitle = 'menu-more-packages-title',
  MenuSalesToolsAdjustmentMessage = 'menu-sales-tools-adjustments-msg',
  MenuSalesToolsAddCustomItem = 'menu-sales-tools-add-custom-item',
  MenuSalesToolsCustomItemDescription = 'menu-sales-tools-custom-item-description',
  MenuSalesToolsCustomItemQuantity = 'menu-sales-tools-custom-item-qty',
  MenuSalesToolsCustomItemType = 'menu-sales-tools-custom-item-type',
  MenuSalesToolsDiscountAmount = 'menu-sales-tools-discount-amount',
  MenuSalesToolsDiscountPercentOfBase = 'menu-sales-tools-discount-percent-of-base',
  MenuSalesToolsExpense = 'menu-sales-tools-expense',
  MenuSalesToolsExpenseNonTaxable = 'menu-sales-tools-expense-non-taxable',
  MenuSalesToolsIntroText = 'menu-sales-tools-intro-text',
  MenuSalesToolsNote = 'menu-sales-tools-note',
  MenuSalesToolsPriceAmount = 'menu-sales-tools-price-amount',
  MenuSalesToolsPriceEach = 'menu-sales-tools-price-each',
  MenuSalesToolsPricePercent = 'menu-sales-tools-price-percent',
  MenuSalesToolsTitle = 'menu-sales-tools-title',
  MenuSectionPropsIntroText = 'menu-section-props-intro-text',
  MenuSectionPropsTitle = 'menu-section-props-title',
  CapMenuSectionPropsTitle = 'cap-menu-section-props-title',
  MenuServicesFinancingAdditionalOptions = 'menu-services-financing-additional-options',
  MenuServicesFinancingIntroText = 'menu-services-financing-intro-text',
  MenuServicesFinancingTitle = 'menu-services-financing-title',
  MenuSizeDescriptiveText = 'menu-size-descriptive-text',
  MenuSizeEndText = 'menu-size-end-text',
  MenuSizeSelect = 'menu-size-select',
  MenuSizeIntroText = 'menu-size-intro-text',
  MenuSizeTitle = 'menu-size-title',
  MenuStyleBracket = 'menu-style-bracket',
  MenuStyleIntroText = 'menu-style-intro-text',
  MenuStylePackageTitle = 'menu-style-package-title',
  MenuStyleRainGutter = 'menu-style-rain-gutter',
  MenuStyleRoofing = 'menu-style-roofing',
  MenuStyleRoofOverhang = 'menu-style-roof-overhang',
  MenuStyleRoofOverhangPerWallPosition = 'menu-style-roof-overhang-per-wall-position',
  MenuStyleSiding = 'menu-style-siding',
  MenuStyleSidingGroup = 'menu-style-siding-group',
  MenuStyleStyleGroup = 'menu-style-style-group',
  MenuStyleStyleGroups = 'menu-style-style-groups',
  MenuStyleStyles = 'menu-style-styles',
  MenuStyleStyleVariations = 'menu-style-style-variations',
  MenuStyleTitle = 'menu-style-title',
  MenuStyleRoofSnoop = 'menu-style-roof-snoop',
  MenuYourDetailsTitle = 'menu-your-details-title',
  MenuYourEstimateTitle = 'menu-your-estimate-title',
  MultipleSavedBuildings = 'multiple-saved-buildings',
  MultipleSelectionsWallsQuantityLabel = 'multiple-selections-walls-quantity-label',
  MultipleSelectionsWallsQuantityLabelSingular = 'multiple-selections-walls-quantity-label-singular',
  None = 'none',
  NoSavedBuildings = 'no-saved-buildings',
  NoSavedBuildingsInstructions = 'no-saved-buildings-instructions',
  OneSavedBuilding = 'one-saved-building',
  OrderThankYouDialogMsg = 'order-thank-you-dialog-msg',
  OutOfRangeError = 'out-of-range-error',
  PlaneEditorInvalidDropPosition = 'plane-editor-invalid-drop-position',
  PackageReplaceConfirmationText = 'package-replace-confirmation-text',
  PdfAdditionalTitle = 'pdf-additional-title',
  PdfAddressBillingAddress = 'pdf-address-billing-address',
  PdfAddressBillingCity = 'pdf-address-billing-city',
  PdfAddressBillingState = 'pdf-address-billing-state',
  PdfAddressBillingZipCode = 'pdf-address-billing-zipcode',
  PdfAddressCustomerAddress = 'pdf-address-customer-address',
  PdfAddressCustomerCity = 'pdf-address-customer-city',
  PdfAddressCustomerCityStateZipCode = 'pdf-address-customer-city-state-zipcode',
  PdfAddressCustomerCityZipCode = 'pdf-address-customer-city-zipcode',
  PdfAddressCustomerEmail = 'pdf-address-customer-email',
  PdfAddressCustomerMobileNumber = 'pdf-address-customer-mobile-number',
  PdfAddressCustomerName = 'pdf-address-customer-name',
  PdfAddressCustomerOrderNumber = 'pdf-address-customer-order-number',
  PdfAddressCustomerPhoneNumber = 'pdf-address-customer-phone-number',
  PdfAddressCustomerState = 'pdf-address-customer-state',
  PdfAddressCustomerZipCode = 'pdf-address-customer-zipcode',
  PdfAddressTitle = 'pdf-address-title',
  PdfBuildingInfoTitle = 'pdf-building-info-title',
  PdfBuildingItemBase = 'pdf-building-item-base',
  PdfBuildingItemBrace = 'pdf-building-item-brace',
  PdfBuildingItemGauge = 'pdf-building-item-gauge',
  PdfBuildingItemLeg = 'pdf-building-item-leg',
  PdfBuildingItemRoofing = 'pdf-building-item-roofing',
  PdfBuildingItemSiding = 'pdf-building-item-siding',
  PdfBuildingItemStyle = 'pdf-building-item-style',
  PdfBuildingRoofMaterial = 'pdf-building-roof-material',
  PdfBuildingRoofOverhang = 'pdf-building-roof-overhang',
  PdfColorItemRoof = 'pdf-color-item-roof',
  PdfColorItemSiding = 'pdf-color-item-siding',
  PdfColorItemTrim = 'pdf-color-item-trim',
  PdfColorItemWainscot = 'pdf-color-item-wainscot',
  PdfColorTitle = 'pdf-color-title',
  PdfDealerPhoneNumber = 'pdf-dealer-phone-number',
  PdfDealerTitle = 'pdf-dealer-title',
  PdfFileName = 'pdf-file-name',
  PdfAttachmentFilenameOverride = 'pdf-attachment-filename-override',
  PdfFloorPlanTitle = 'pdf-floor-plan-title',
  PdfFooterOrderNumber = 'pdf-footer-order-number',
  PdfFooterPageNumber = 'pdf-footer-page-number',
  PdfHeaderOrderDate = 'pdf-header-order-date',
  PdfHeaderQrCodeTitle = 'pdf-header-qr-code-title',
  PdfHeaderSalesRep = 'pdf-header-sales-rep',
  PdfInstallationEngineerCertified = 'pdf-installation-engineer-certified',
  PdfInstallationSurface = 'pdf-installation-surface',
  PdfInstallationTitle = 'pdf-installation-title',
  PdfLineItemDescription = 'pdf-line-item-description',
  PdfLineItemPrice = 'pdf-line-item-price',
  PdfLineItemQuantity = 'pdf-line-item-quantity',
  PdfLineItemSKU = 'pdf-line-item-sku',
  PdfLineItemUnitPrice = 'pdf-line-item-unit-price',
  PdfPaymentTitle = 'pdf-payment-title',
  PdfSidewallHeight = 'pdf-sidewall-height',
  PdfSizeLegHeight = 'pdf-size-leg-height',
  PdfSizeLength = 'pdf-size-length',
  PdfSizeTitle = 'pdf-size-title',
  PdfSizeWidth = 'pdf-size-width',
  PdfSignatureLabel = 'pdf-signature-label',
  PdfDateLabel = 'pdf-date-label',
  PdfDateLabel2 = 'pdf-date-label-2',
  PdfExtraSignatureLabel = 'pdf-extra-signature-label',
  PdfSignatureAgreementTitle = 'pdf-signature-agreement-title',
  PdfExtraDateLabel = 'pdf-extra-date-label',
  PdfExtraDateLabel2 = 'pdf-extra-date-label-2',
  PdfTotalsCreditCardFee = 'pdf-totals-credit-card-fee',
  PdfTotalsCustomCharge = 'pdf-totals-custom-charge',
  PdfTotalsDelivery = 'pdf-totals-delivery',
  PdfTotalsDeliveryFeeSubtotal = 'pdf-totals-delivery-fee-subtotal',
  PdfTotalsDepositAmount = 'pdf-totals-deposit-amount',
  PdfTotalsDepositDiscount = 'pdf-totals-deposit-discount',
  PdfTotalsDepositPaid = 'pdf-totals-deposit-paid',
  PdfTotalsDepositToOrder = 'pdf-totals-deposit-to-order',
  PdfTotalsNonTaxableServices = 'pdf-totals-non-taxable-services',
  PdfTotalsProcessingFee = 'pdf-totals-processing-fee',
  PdfTotalsRemainingDue = 'pdf-totals-remaining-due',
  PdfTotalsSalesTax = 'pdf-totals-sales-tax',
  PdfTotalsSalesTaxExemptLabel = 'pdf-totals-sales-tax-exempt-label',
  PdfTotalsSalesTaxVat = 'pdf-totals-sales-tax-vat',
  PdfTotalsSalesTaxVatExemptLabel = 'pdf-totals-sales-tax-vat-exempt-label',
  PdfTotalsSubtotal = 'pdf-totals-subtotal',
  PdfTotalsTaxableServices = 'pdf-totals-taxable-services',
  PdfTotalsTitle = 'pdf-totals-title',
  PdfTotalsTotalOrderAmount = 'pdf-totals-total-order-amount',
  PreviewingChangesMessage = 'previewing-changes-message',
  PreviewingChangesPricingMessage = 'previewing-changes-pricing-message',
  PrintErrorDialogMessage = 'print-error-dialog-message',
  PromotionalDesktopMessage = 'promotional-desktop-message',
  PromotionalMobileMessage = 'promotional-mobile-message',
  QuoteBtn = 'quote-btn',
  QuoteDialogEndText = 'quote-dialog-end-text',
  QuoteDialogError = 'quote-dialog-error',
  QuoteDialogIntroDigitalSignatureText = 'quote-dialog-intro-digital-signature-text',
  QuoteDialogIntroText = 'quote-dialog-intro-text',
  QuoteDialogSubmit = 'quote-dialog-submit',
  QuoteDialogSubmiting = 'quote-dialog-submiting',
  QuoteDialogTermsAndConditions = 'quote-dialog-terms-and-conditions',
  QuoteDialogTitle = 'quote-dialog-title',
  OpenTutorialButton = 'open-tutorial-button',
  RecentSaveActionBanner = 'recent-save-action-banner',
  RecentSubmitActionBanner = 'recent-submit-action-banner',
  Remove = 'remove',
  RemoveSectionLabel = 'remove-section-label',
  ReturnToDesign = 'return-to-design',
  RequiredError = 'required-error',
  RightSide = 'right-side',
  RoofDialogRoofOverhangPerWallPosition = 'roof-dialog-roof-overhang-per-wall-position',
  RoofDialogAllRoofs = 'roof-dialog-all-roofs',
  RoofDialogThisRoof = 'roof-dialog-this-roof',
  RoofDialogRoof = 'roof-dialog-roof',
  SalesToolCustomDepositAmount = 'sales-tool-custom-deposit-amount',
  SalesToolCustomDepositPercentage = 'sales-tool-custom-deposit-percentage',
  SalesToolCustomPercentage = 'sales-tool-custom-percentage',
  SalesToolDepositAmount = 'sales-tool-deposit-amount',
  SalesToolDepositAmountExceededTotalError = 'sales-tool-deposit-amount-exceeded-total-error',
  SalesToolDepositAmountInput = 'sales-tool-deposit-amount-input',
  SalesToolDepositPercentageInput = 'sales-tool-deposit-percentage-input',
  SalesToolSalesTax = 'sales-tool-sales-tax',
  SalesToolSalesTaxExceededTotalError = 'sales-tool-sales-tax-exceeded-total-error',
  SalesToolSalesTaxExempt = 'sales-tool-sales-tax-exempt',
  SalesToolSaveDraftBtn = 'sales-tool-save-draft-btn',
  SalesToolSaveDraftMessage = 'sales-tool-save-draft-message',
  SalesToolSaveDraftTitle = 'sales-tool-save-draft-title',
  SalesToolStandardDepositPercentage = 'sales-tool-standard-deposit-percentage',
  SalesToolStandardTaxPercentage = 'sales-tool-standard-tax-percentage',
  SalesToolDepositDiscountSubtotal = 'sales-tool-deposit-discount-subtotal',
  SalesToolDepositDiscountDeposit = 'sales-tool-deposit-discount-deposit',
  SalesToolsSupplierSelectBasedOnZipCode = 'sales-tools-supplier-select-based-on-zip-code',
  SalesToolsSupplierSelectTitle = 'sales-tools-supplier-select-title',
  SalesTool2dFloorplanTitle = 'menu-sales-tools-2d-floorplan',
  SalesTool2dFloorplanBtn = 'menu-sales-tools-download-floorplan',
  SalesTool2dFloorplanEmail = 'menu-sales-tools-floorplan-email',
  SaveBtn = 'save-btn',
  SavedComponentsNoLongerAvailableTitle = 'saved-components-no-longer-available-title',
  SavedComponentsNoLongerAvailableDescription = 'saved-components-no-longer-available-description',
  SavedDesignsPageEstimatedPrice = 'saved-designs-page-estimate-price',
  SavedDesignsPageTitle = 'saved-designs-page-title',
  SavedSupplierNoLongerAvailableTitle = 'saved-supplier-no-longer-available-title',
  SavedSupplierNoLongerAvailableDescription = 'saved-supplier-no-longer-available-description',
  SaveDialogEndText = 'save-dialog-end-text',
  SaveDialogIntroDigitalSignatureText = 'save-dialog-intro-digital-signature-text',
  SaveDialogIntroText = 'save-dialog-intro-text',
  SaveDialogTermsAndConditions = 'save-dialog-terms-and-conditions',
  SaveDialogTitle = 'save-dialog-title',
  SaveToListEmailBody = 'save-to-list-email-body',
  SaveToListEmailBuildingDimensions = 'save-to-list-email-building-dimensions',
  SaveToListEmailBuildingStyle = 'save-to-list-email-building-style',
  SaveToListEmailCopyrightFooter = 'save-to-list-email-copyright-footer',
  SaveToListEmailCustomerInfoHeader = 'save-to-list-email-customer-info-header',
  SaveToListEmailDesignLink = 'save-to-list-email-design-link',
  SectionLabel = 'section-label',
  SectionSelectorBackLean = 'section-selector-back-lean',
  SectionSelectorCenterInnerStorage = 'section-selector-center-inner-storage',
  SectionSelectorCenterLeftStorage = 'section-selector-center-left-storage',
  SectionSelectorCenterRightStorage = 'section-selector-center-right-storage',
  SectionSelectorCenterSection = 'section-selector-center-section',
  SectionSelectorFrontLean = 'section-selector-front-lean',
  SectionSelectorLeftInnerStorage = 'section-selector-left-inner-storage',
  SectionSelectorLeftLean = 'section-selector-left-lean',
  SectionSelectorRightInnerStorage = 'section-selector-right-inner-storage',
  SectionSelectorRightLean = 'section-selector-right-lean',
  SectionSelectorSection = 'section-selector-section',
  SectionSizeSelectorLegHeight = 'section-size-selector-leg-height',
  SectionSizeSelectorLength = 'section-size-selector-length',
  SectionSizeSelectorWidth = 'section-size-selector-width',
  SectionWallFootprintAuxiliaryHeight = 'section-wall-footprint-auxiliary-height',
  SelectorLabelBrace = 'selector-label-braces',
  SelectorLabelCeiling = 'selector-label-ceiling',
  SelectorLabelInstallationSurface = 'selector-label-installation-surface',
  SelectorLabelJTrim = 'selector-label-j-trim',
  SelectorLabelLeg = 'selector-label-leg',
  SelectorLabelLegFootprint = 'selector-label-leg-footprint',
  SelectorLabelRoofExtension = 'selector-label-roof-extension',
  SelectorLabelRoofing = 'selector-label-roofing',
  SelectorLabelRoofPitch = 'selector-label-roof-pitch',
  SelectorLabelStorage = 'selector-label-storage',
  SelectorLabelStorageDepth = 'selector-label-storage-depth',
  SelectorLabelTrim = 'selector-label-trim',
  SelectorLabelTruss = 'selector-label-truss',
  SelectorLabelFrontWraparound = 'selector-label-front-wraparound',
  SelectorLabelFrontWraparoundWidth = 'selector-label-front-wraparound-width',
  SelectorLabelBackWraparoundWidth = 'selector-label-back-wraparound-width',
  SelectorLabelBackWraparound = 'selector-label-back-wraparound',
  ShareEmailPhoneAddressField = 'share-email-phone-address-field',
  ShareEmailPhoneMessageField = 'share-email-phone-message-field',
  ShareDialogSavingDraft = 'share-dialog-saving-draft-1',
  ShareDialogSavedDraft = 'share-dialog-saved-draft',
  ShareDialogTitle = 'share-dialog-title',
  ShareButtonFacebook = 'share-button-facebook',
  ShareButtonPinterest = 'share-button-pinterest',
  ShareButtonTwitter = 'share-button-twitter',
  ShareButtonPhone = 'share-button-phone',
  ShareEmailSubject = 'share-email-subject',
  SharePinterestContent = 'share-pinterest-content',
  SharePreviewDescription = 'share-preview-description',
  SharePreviewTitle = 'share-preview-title',
  ShareTwitterTags = 'share-twitter-tags',
  ShareTwitterContent = 'share-twitter-content',
  SizeLabel = 'size-label',
  SizeSelectorCustomGroup = 'size-selector-custom-group',
  SizeSelectorStandardGroup = 'size-selector-standard-group',
  SnackbarComponentCantAddOnWall = 'snackbar-component-cant-add-on-wall',
  SnackbarComponentCantFit = 'snackbar-component-cant-fit',
  SnackbarComponentSizeCantFit = 'snackbar-component-size-cant-fit',
  SnackbarPackageComponentCantFit = 'snackbar-package-component-cant-fit',
  SnackbarPackageCantFit = 'snackbar-package-cant-fit',
  SnackbarPackageCantBeRemoved = 'snackbar-package-cant-be-removed',
  SnackbarSelectToMoveDoor = 'snackbar-select-to-move-door',
  SnackbarSelectToMoveWindow = 'snackbar-select-to-move-window',
  SnackbarSelectToMoveVent = 'snackbar-select-to-move-vent',
  SnackbarSelectToMoveItem = 'snackbar-select-to-move-item',
  SnackbarItemCantBeAdded = 'snackbar-item-cant-be-added',
  SnackbarMaxNumberOfCupolasReached = 'snackbar-max-number-of-cupolas-reached',
  SnackbarSceneEnvironmentRemoved = 'snackbar-scene-environment-removed',
  SnackbarClickItemToSelect = 'snackbar-click-item-to-select',
  ThankYouDialogDialogMsg = 'thank-you-dialog-msg',
  TimeFromNowLabel = 'time-from-now-label',
  TimeFromNowJustNow = 'time-from-now-just-now',
  TimeFromNowDateFormat = 'time-from-now-date-format',
  TimeFromNowTimeFormat = 'time-from-now-time-format',
  TimeFromNowToday = 'time-from-now-today',
  TimeFromNowYesterday = 'time-from-now-yesterday',
  TutorialNextButton = 'tutorial-next-button',
  TutorialCloseButton = 'tutorial-close-button',
  TutorialSkipButton = 'tutorial-skip-button',
  TutorialGotItButton = 'tutorial-got-it-button',
  Undo = 'undo',
  ViewerEstimateForManuallySelectedRegion = 'viewer-estimate-for-manually-selected-region',
  ViewerEstimateNoRegionPricing = 'viewer-estimate-no-region-pricing',
  ViewerEstimateNoPricing = 'viewer-estimate-no-pricing',
  ViewerDetailsForState = 'viewer-details-for-state',
  ViewerDetailsForZip = 'viewer-details-for-zip',
  ViewerDetailsStateRequired = 'viewer-details-state-required',
  ViewerDetailsZipRequired = 'viewer-details-zip-required',
  ViewerEstimate = 'viewer-estimate',
  ViewerEstimateFor = 'viewer-estimate-for',
  ViewerEstimateForNoDeliveryReturned = 'viewer-estimate-for-no-delivery-returned',
  ViewerEstimateStateRequired = 'viewer-estimate-state-required',
  ViewerEstimateZipRequired = 'viewer-estimate-zip-required',
  ViewerNavCenterWallComponents = 'viewer-nav-center-wall-components',
  ViewerNavClearWall = 'viewer-nav-clear-wall',
  ViewerNavHome = 'viewer-nav-home',
  ViewerNavIn = 'viewer-nav-in',
  ViewerNavLeft = 'viewer-nav-left',
  ViewerNavOut = 'viewer-nav-out',
  ViewerNavReset = 'viewer-nav-reset',
  ViewerNavInteriorToggle = 'viewer-nav-interior-toggle',
  ViewerNavRight = 'viewer-nav-right',
  ViewerNavScene = 'viewer-nav-scene',
  ViewerNavUndo = 'viewer-nav-undo',
  ViewerRoofSize = 'viewer-roof-size',
  WallDialogEnclosure = 'wall-dialog-enclosure',
  WallDialogAllWallsTab = 'wall-dialog-all-walls-tab',
  WallDialogSectionTab = 'wall-dialog-section-walls-tab',
  WallDialogLeanToTab = 'wall-dialog-lean-to-walls-tab',
  WallDialogThisWallTab = 'wall-dialog-this-wall-tab',
  AddOptionButtonCupola = 'add-option-button-cupola',
  AddOptionButtonRoofSnoop = 'add-option-button-roof-snoop',
  RoofSnoopPropertyMenuTitle = 'roof-snoop-property-menu-title',
  MenuDoorsWindowsRoofSnoop = 'menu-doors-windows-roof-snoop',
  RoofSnoopPropertyPropertyMenuOptions = 'roof-snoop-property-menu-options',
  CopiedToClipboard = 'copied-to-clipboard',

  /* Boost keys */
  BoostAdditionalOptionsLabel = 'boost-additional-options-label',
  BoostAddStorage = 'boost-add-storage',
  BoostARButton = 'boost-ar-button',
  BoostARDialogDesignReadyDesktop = 'boost-ar-dialog-design-ready-desktop',
  BoostARDialogEmailInputLabel = 'boost-ar-dialog-email-input-label',
  BoostARDialogLinkSent = 'boost-ar-dialog-link-sent',
  BoostARDialogLoadingDescription = 'boost-ar-dialog-loading-description',
  BoostARDialogLoadingSubtitle = 'boost-ar-dialog-loading-subtitle',
  BoostARDialogOr = 'boost-ar-dialog-or',
  BoostARDialogQRCodeTitle = 'boost-ar-dialog-qr-code-title',
  BoostARDialogReady = 'boost-ar-dialog-ready',
  BoostARDialogRetryIn = 'boost-ar-dialog-retry-in',
  BoostARDialogSendLink = 'boost-ar-dialog-send-link',
  BoostARDialogSupportedDevices = 'boost-ar-dialog-supported-devices',
  BoostARDialogTitle = 'boost-ar-dialog-title',
  BoostARDialogUnsupportedFirstText = 'boost-ar-dialog-unsupported-first-text',
  BoostARDialogUnsupportedSecondText = 'boost-ar-dialog-unsupported-second-text',
  BoostARDialogViewBtn = 'boost-ar-dialog-view-btn',
  BoostAutoSaveDesignDialogMessage = 'boost-auto-save-design-dialog-message',
  BoostAutoSaveDesignDialogTitle = 'boost-auto-save-design-dialog-title',
  BoostAutoSaveDesignDialogCancelButton = 'boost-auto-save-design-dialog-cancel-button',
  BoostAutoSaveDesignDialogRestoreButton = 'boost-auto-save-design-dialog-restore-button',
  BoostCenterItemsButton = 'boost-center-items-button',
  BoostCenterStorage = 'boost-center-storage',
  BoostClearItemsButton = 'boost-clear-items-button',
  BoostChangeLocationButton = 'boost-change-location-button',
  BoostCheckoutBuildingDetailsTitle = 'boost-checkout-building-details-title',
  BoostCheckoutBuildingImagesTitle = 'boost-checkout-building-images-title',
  BoostCheckoutButton = 'boost-checkout-button',
  BoostCheckoutContactInfoSubtitle = 'boost-checkout-contact-info-subtitle',
  BoostCheckoutContactInfoTitle = 'boost-checkout-contact-info-title',
  BoostCheckoutContinueToPaymentButtonLabel = 'boost-continue-to-payment-button-label',
  BoostCheckoutDeliveryInfoTitle = 'boost-checkout-delivery-info-title',
  BoostCheckoutDeliveryAndContactInfoTitle = 'boost-checkout-delivery-and-contact-info-title',
  BoostCheckoutDialogTitle = 'boost-checkout-dialog-title',
  BoostCheckoutDialogErrorTitle = 'boost-checkout-dialog-error-title',
  BoostCheckoutDueToday = 'boost-checkout-due-today',
  BoostCheckoutDueTodayPercentage = 'boost-checkout-due-today-percentage',
  BoostCheckoutDueUponDelivery = 'boost-checkout-due-upon-delivery',
  BoostCheckoutNextStepButtonLabel = 'boost-checkout-next-step-button-label',
  BoostCheckoutOrderNowButtonLabel = 'boost-checkout-order-now-button-label',
  BoostCheckoutPaymentTitle = 'boost-checkout-payment-title',
  BoostCheckoutPaymentTypeLabel = 'boost-checkout-payment-type-label',
  BoostCheckoutReturnToDesignMessage = 'boost-checkout-return-to-design-message',
  BoostCheckoutReturnToDesignButtonLabel = 'boost-checkout-return-to-design-button-label',
  BoostCheckoutSubTotal = 'boost-checkout-subtotal',
  BoostCheckoutTotalEstimate = 'boost-checkout-total-estimate',
  BoostComponentLabelCurrentSelection = 'boost-component-label-current-selection',
  BoostContactUs = 'boost-contact-us',
  BoostCupolaQuantity = 'boost-cupola-quantity',
  BoostCustomColorText = 'boost-custom-color-text',
  BoostDeliveryTo = 'boost-delivery-to',
  BoostDesignSummaryTitle = 'boost-design-summary-title',
  BoostDetailsButton = 'boost-details-button',
  BoostDetailsCreditCardFee = 'boost-details-credit-card-fee',
  BoostDetailsProcessingFee = 'boost-details-processing-fee',
  BoostDetailsSubtotalForNoDeliveryReturned = 'boost-details-subtotal-for-no-delivery-returned',
  BoostDetailsTotalForNoDeliveryReturned = 'boost-details-total-for-no-delivery-returned',
  BoostDetailsTaxableServices = 'boost-details-taxable-services',
  BoostDoneLabel = 'boost-done-label',
  BoostDownloadCustomPdf = 'boost-download-custom-pdf',
  BoostDownloadCustomPdfButton = 'boost-download-custom-pdf-button',
  BoostDuplicateComponent = 'boost-duplicate-component',
  BoostEditStorage = 'boost-edit-storage',
  BoostEmailUs = 'boost-email-us',
  BoostEmailButton = 'boost-email-button',
  BoostGuideLabel = 'boost-guide-label',
  BoostHeaderFaveIconText = 'boost-header-fave-icon-text',
  BoostHeaderHelpContactIconText = 'boost-header-help-contact-icon-text',
  BoostHeaderSalesSignIn = 'boost-header-sales-sign-in',
  BoostHeaderSalesToolsButtonLabel = 'boost-header-sales-tools-button-label',
  BoostHeaderShareIconText = 'boost-header-share-icon-text',
  BoostHelpContactDialogTitle = 'boost-help-contact-dialog-title',
  BoostHelpModalCallUs = 'boost-help-modal-call-us',
  BoostHelpModalCopyEmail = 'boost-help-modal-copy-email',
  BoostHelpModalEmailUs = 'boost-help-modal-email-us',
  BoostHideDetailsButtonLabel = 'boost-hide-details-button-label',
  BoostInstallationRequirements = 'boost-installation-requirements',
  BoostInstallationSurfaceLabel = 'boost-installation-surface-label',
  BoostLineItemAccessories = 'boost-line-item-accessories',
  BoostLineItemAdditionalInformation = 'boost-line-item-additional-information',
  BoostLineItemBodyAndFrame = 'boost-line-item-body-and-frame',
  BoostLineItemDoorsAndRamps = 'boost-line-item-doors-and-ramps',
  BoostLineItemFlooringAndInterior = 'boost-line-item-flooring-and-interior',
  BoostLineItemOthers = 'boost-line-item-others',
  BoostLineItemWindows = 'boost-line-item-windows',
  BoostLoadBuildingButton = 'boost-load-building-button',
  BoostLocationDialogTermsAndConditions = 'boost-location-dialog-terms-and-conditions',
  BoostLocationDialogZipCodePlaceholder = 'boost-location-dialog-zip-code-placeholder',
  BoostLoadBuildingDialogTitle = 'boost-load-building-dialog-title',
  BoostLoadBuildingDialogOpen = 'boost-load-building-dialog-open',
  BoostLoadBuildingDialogIntroText = 'boost-load-building-dialog-intro-text',
  BoostLoadBuildingDialogEmailIdPlaceholder = 'boost-load-building-dialog-email-id-placeholder',
  BoostLoginButtonLabel = 'boost-login-button-label',
  BoostLogoutButtonLabel = 'boost-logout-button-label',
  BoostMenuColorsIntroText = 'boost-menu-colors-intro-text',
  BoostMenuColorsTitle = 'boost-menu-colors-title',
  BoostMenuDetailsIntroText = 'boost-menu-details-intro-text',
  BoostMenuDoorsWindowsAddItemsToRoof = 'boost-menu-doors-windows-add-items-to-roof',
  BoostMenuDoorsWindowsAddItemsToWall = 'boost-menu-doors-windows-add-items-to-wall',
  BoostMenuDoorsWindowsArrangeItems = 'boost-menu-doors-windows-arrange-items',
  BoostMenuDoorsWindowsBuildingLayoutIntroText = 'boost-menu-doors-windows-building-layout-intro-text',
  BoostMenuDoorsWindowsCupola = 'boost-menu-doors-windows-cupola',
  BoostMenuDoorsWindowsCustomLayoutAddPackageItems = 'boost-menu-doors-windows-custom-layout-add-package-items',
  BoostMenuDoorsWindowsCustomLayoutIntroText = 'boost-menu-doors-windows-custom-layout-intro-text',
  BoostMenuDoorsWindowsRoofSnoop = 'boost-menu-doors-windows-roof-snoop',
  BoostMenuDoorsWindowsSelectedLayout = 'boost-menu-doors-windows-selected-layout',
  BoostMenuEstimateDisclaimer = 'boost-menu-estimate-disclaimer',
  BoostMenuEstimateTotalEstimate = 'boost-menu-estimate-total-estimate',
  BoostMenuFlooringFloorJoists = 'boost-menu-flooring-floor-joists',
  BoostMenuFlooringIntroText = 'boost-menu-flooring-intro-text',
  BoostMenuInteriorAddItemsToWall = 'boost-menu-interior-add-items-to-wall',
  BoostMenuInteriorInsulation = 'boost-menu-interior-insulation',
  BoostMenuInteriorIntroText = 'boost-menu-interior-intro-text',
  BoostMenuInteriorLoft = 'boost-menu-interior-loft',
  BoostMenuInteriorAddPackageItems = 'boost-menu-interior-add-package-items',
  BoostMenuInteriorRoofFinishing = 'boost-menu-interior-roof-finishing',
  BoostMenuInteriorShelving = 'boost-menu-interior-shelving',
  BoostMenuInteriorWalls = 'boost-menu-interior-walls',
  BoostMenuPackagesIntroText = 'boost-menu-packages-intro-text',
  BoostMenuSavedDesignsHeading = 'boost-menu-saved-designs-heading',
  BoostMenuSectionPropsIntroText = 'boost-menu-section-props-intro-text',
  BoostMenuSizeDescriptiveText = 'boost-menu-size-descriptive-text',
  BoostMenuSizeEndText = 'boost-menu-size-end-text',
  BoostMenuSizeIntroText = 'boost-menu-size-intro-text',
  BoostMenuSizeSelectHelperText = 'boost-menu-size-select-helper-text',
  BoostMenuStyleBase = 'boost-menu-style-base',
  BoostMenuStyleGroupCategoryText = 'boost-menu-style-group-category-text',
  BoostMenuStyleIntroText = 'boost-menu-style-intro-text',
  BoostMenuStylePorch = 'boost-menu-style-porch',
  BoostMenuStylePorchDepth = 'boost-menu-style-porch-depth',
  BoostMenuStylePorchLength = 'boost-menu-style-porch-length',
  BoostMenuStylePorchRailing = 'boost-menu-style-porch-railing',
  BoostMenuStylePorchSidewallDepth = 'boost-menu-style-porch-sidewall-depth',
  BoostMenuStyleRoofing = 'boost-menu-style-roofing',
  BoostMenuStyleRoofOverhang = 'boost-menu-style-roof-overhang',
  BoostMenuStyleRoofPitch = 'boost-menu-style-roof-pitch',
  BoostMenuStyleRoofSnoop = 'boost-menu-style-roof-snoop',
  BoostMenuStyleSidewallHeight = 'boost-menu-style-sidewall-height',
  BoostMenuStyleSiding = 'boost-menu-style-siding',
  BoostMenuStyleSidingGroup = 'boost-menu-style-siding-group',
  BoostMenuStyleStyles = 'boost-menu-style-styles',
  BoostMenuStyleStyleVariations = 'boost-menu-style-style-variations',
  BoostMenuStyleTrim = 'boost-menu-style-trim',
  BoostMenuTitleDetails = 'boost-menu-title-details',
  BoostMenuTitleEstimate = 'boost-menu-title-estimate',
  BoostMenuTitleFlooring = 'boost-menu-title-flooring',
  BoostMenuTitleInformation = 'boost-menu-title-information',
  BoostMenuTitleInterior = 'boost-menu-title-interior',
  BoostMenuTitleSize = 'boost-menu-title-size',
  BoostMenuTitleSectionProps = 'boost-menu-title-section-props',
  BoostNotVisibleOnModel = 'boost-not-visible-on-model',
  BoostOpenSalesViewButtonLabel = 'boost-open-sales-view-button-label',
  BoostOrderDetailsCardTitle = 'boost-order-details-card-title',
  BoostOrderEstimateCardTitle = 'boost-order-estimate-card-title',
  BoostOrderDetailsDescColumnHeader = 'boost-order-details-desc-column-header',
  BoostOrderDetailsPriceColumnHeader = 'boost-order-details-price-column-header',
  BoostOrderDetailsQtyColumnHeader = 'boost-order-details-qty-column-header',
  BoostOrderDetailsSkuColumnHeader = 'boost-order-details-sku-column-header',
  BoostOrderSummaryDelivery = 'boost-order-summary-delivery',
  BoostOrderSummaryDepositDiscounts = 'boost-order-summary-deposit-discounts',
  BoostOrderSummaryDepositAmountDueNow = 'boost-order-summary-deposit-amount-due-now',
  BoostOrderSummaryDueToday = 'boost-order-summary-due-today',
  BoostOrderSummaryFree = 'boost-order-summary-free',
  BoostOrderSummaryPayInFull = 'boost-order-summary-pay-in-full',
  BoostOrderSummarySalesTaxTotalVat = 'boost-order-summary-sales-tax-total-vat',
  BoostOrderSummaryServiceFees = 'boost-order-summary-service-fees',
  BoostOrderSummaryTaxes = 'boost-order-summary-taxes',
  BoostOrderSummaryTaxesWithPercentage = 'boost-order-summary-taxes-with-percentage',
  BoostOrderSummaryTitle = 'boost-order-summary-title',
  BoostOrderSummaryValue = 'boost-order-summary-value',
  BoostPackageInformationTitle = 'boost-package-information-title',
  BoostPackageOptionLabel = 'boost-package-option-label',
  BoostPaymentACHOption = 'boost-payment-ach-option',
  BoostPaymentCashCheckOption = 'boost-payment-cash-check-option',
  BoostPaymentCreditCardOption = 'boost-payment-credit-card-option',
  BoostPaymentPayByBankOption = 'boost-payment-pay-by-bank-option',
  BoostPaymentDeliveryInstallationSetLocation = 'BoostPaymentDeliveryInstallationSetLocation',
  BoostPaymentDepositLabel = 'boost-payment-deposit-label',
  BoostPaymentErrorTitle = 'boost-payment-error-title',
  BoostPaymentErrorSubtitle = 'boost-payment-error-subtitle',
  BoostPaymentFinancingOption = 'boost-payment-financing-option',
  BoostCheckoutPaymentMethodACHAccountNumberPlaceholder = 'boost-checkout-payment-method-ach-account-number-placeholder',
  BoostCheckoutPaymentMethodACHOwnerNamePlaceholder = 'boost-checkout-payment-method-ach-owner-name-placeholder',
  BoostCheckoutPaymentMethodACHRoutingNumberPlaceholder = 'boost-checkout-payment-method-ach-routing-number-placeholder',
  BoostCheckoutPaymentMethodACHSubtitle = 'boost-checkout-payment-method-ach-subtitle',
  BoostCheckoutPaymentMethodCreditCardLabel = 'boost-checkout-payment-method-credit-card-label',
  BoostCheckoutPaymentMethodCreditCardPlaceholder = 'boost-checkout-payment-method-credit-card-placeholder',
  BoostCheckoutPaymentMethodCVCLabel = 'boost-checkout-payment-method-cvc-label',
  BoostCheckoutPaymentMethodCVCPlaceholder = 'boost-checkout-payment-method-cvc-placeholder',
  BoostCheckoutPaymentMethodCVC4DigitsPlaceholder = 'boost-checkout-payment-method-cvc-4-digits-placeholder',
  BoostCheckoutPaymentMethodExpiryDateLabel = 'boost-checkout-payment-method-expiry-date-label',
  BoostCheckoutPaymentMethodExpiryDatePlaceholder = 'boost-checkout-payment-method-expiry-date-placeholder',
  BoostCheckoutPaymentMethodNameLabel = 'boost-checkout-payment-method-name-label',
  BoostCheckoutPaymentMethodNamePlaceholder = 'boost-checkout-payment-method-name-placeholder',
  BoostCheckoutPaymentMethodRequiredFields = 'boost-checkout-payment-method-required-fields',
  BoostPaymentOptions = 'boost-payment-options',
  BoostPaymentOptionsButtonLabel = 'boost-payment-options-button-label',
  BoostPaymentOptionsDialog = 'boost-payment-options-dialog',
  BoostPaymentOptionsFormattedButton = 'boost-payment-options-formatted-button',
  BoostPaymentTotalDescriptionLabel = 'boost-payment-total-description-label',
  BoostPaymentViewTermsLabel = 'boost-payment-view-terms-label',
  BoostPriceLabel = 'boost-price-label',
  BoostPriceAmountNote = 'boost-price-amount-note',
  BoostPrintOrder = 'boost-print-order',
  BoostPromoHeaderContactTextNarrow = 'boost-promo-header-contact-text-narrow',
  BoostPromoHeaderContactTextWide = 'boost-promo-header-contact-text-wide',
  BoostQuickAccessBarAR = 'boost-quick-access-bar-ar',
  BoostQuickAccessBarShare = 'boost-quick-access-bar-share',
  BoostQuoteButton = 'boost-quote-button',
  BoostQuoteBillingAddressCheckbox = 'email-quote-billing-address-checkbox',
  BoostQuoteDefaultBillingStateLabel = 'boost-quote-default-billing-state-label',
  BoostQuoteDefaultDeliveryStateLabel = 'boost-quote-default-delivery-state-label',
  BoostMovePackageComponentMessage = 'boost-move-package-component-message',
  BoostRemoveComponent = 'boost-remove-component',
  BoostRemovePackageMessage = 'boost-remove-package-message',
  BoostRentToOwnEstimateLabel = 'boost-rent-to-own-estimate-label',
  BoostSalesLoginButton = 'boost-sales-login-button',
  BoostSalesLoginDialogTitle = 'boost-sales-login-dialog-title',
  BoostSalesLoginMessage = 'boost-sales-login-message',
  BoostSalesLoginPlaceHolder = 'boost-sales-login-placeholder',
  BoostSalesToolsAddCustomLineItem = 'boost-sales-tools-add-custom-line-item',
  BoostSalesToolsCopyDesignLink = 'boost-sales-tools-copy-design-link',
  BoostSalesToolsCreateDesignLink = 'boost-sales-tools-create-design-link',
  BoostSalesToolsCustomLineItemsAddButton = 'boost-sales-tools-custom-line-items-add-button',
  BoostSalesToolsCustomLineItemsTitle = 'boost-sales-tools-custom-line-items-title',
  BoostSalesToolsCustomSalesTaxHelperText = 'boost-sales-tools-custom-sales-tax-helper-text',
  BoostSalesToolsCustomSalesTaxLabel = 'boost-sales-tools-custom-sales-tax-label',
  BoostSalesToolsDepositAmount = 'boost-sales-tools-deposit-amount',
  BoostSalesToolsDepositAmountZeroError = 'boost-sales-tools-deposit-amount-zero-error',
  BoostSalesToolsDepositStandardDefault = 'boost-sales-tools-deposit-standard-default',
  BoostSalesToolsDepositPercentZeroError = 'boost-sales-tools-deposit-percent-zero-error',
  BoostSalesToolsDepositDiscountAmount = 'boost-sales-tools-deposit-discount-amount',
  BoostSalesToolsDepositDiscountPercentage = 'boost-sales-tools-deposit-discount-percentage',
  BoostSalesToolsDepositDiscountExceeded = 'boost-sales-tools-deposit-discount-exceeded',
  BoostSalesToolsDealerDiscount = 'boost-sales-tools-dealer-discount',
  BoostSalesToolsDealerDepositDiscount = 'boost-sales-tools-dealer-deposit-discount',
  BoostSalesToolsDepositSectionLabel = 'boost-sales-tools-deposit-section-label',
  BoostSalesToolsDepositPercentage = 'boost-sales-tools-deposit-percentage',
  BoostSalesToolsDesignDownloadFloorplan = 'boost-sales-tools-design-download-floorplan',
  BoostSalesToolsDesignSectionLabel = 'boost-sales-tools-design-section-label',
  BoostSalesToolsDiscountsAdjustmentsLabel = 'boost-sales-tools-discounts-adjustments-label',
  BoostSalesToolsInvalidPercentageValue = 'boost-sales-tools-invalid-percentage-value',
  BoostSalesToolsRegionAutoSelect = 'boost-sales-tools-region-auto-select',
  BoostSalesToolsSupplierSelect = 'boost-sales-tools-supplier-select',
  BoostSalesToolsTaxSectionLabel = 'boost-sales-tools-tax-section-label',
  BoostSalesToolsTitle = 'boost-sales-tools-title',
  BoostSalesViewLoginFinishing = 'boost-sales-view-login-finishing',
  BoostSaveCurrentDesignDialogDescription = 'boost-save-current-design-dialog-description',
  BoostSaveCurrentDesignDialogNotNow = 'boost-save-current-design-dialog-not-now',
  BoostSaveCurrentDesignDialogSave = 'boost-save-current-design-dialog-save',
  BoostSaveCurrentDesignDialogTitle = 'boost-save-current-design-dialog-title',
  BoostSavedDesignsNoSavedDesignsLine1 = 'boost-saved-designs-no-saved-designs-line-1',
  BoostSavedDesignsNoSavedDesignsLine2 = 'boost-saved-designs-no-saved-designs-line-2',
  BoostSavedDesignsNoSavedDesignsSaveCurrentDesign = 'boost-saved-designs-no-saved-designs-save-current-design',
  BoostSavedDesignsShareLink = 'boost-saved-designs-share-link',
  BoostSavedDesignsViewLink = 'boost-saved-designs-view-link',
  BoostSceneEnvironmentButton = 'boost-scene-environment-button',
  BoostSceneSelectionTitle = 'boost-scene-selection-title',
  BoostSectionSelectorLabel = 'boost-section-selector-label',
  BoostSecurePaymentMessage = 'boost-secure-payment-message',
  BoostSelectedComponentLabel = 'boost-selected-component-label',
  BoostSetLocation = 'boost-set-location',
  BoostShareDialogButton = 'boost-share-dialog-button',
  BoostShareModalButtonCopyLink = 'boost-share-modal-button-copy-link',
  BoostShareModalButtonCopyLinkSuccess = 'boost-share-modal-button-copy-link-success',
  BoostShareModalButtonEmail = 'boost-share-modal-button-email',
  BoostShareModalButtonFacebook = 'boost-share-modal-button-facebook',
  BoostShareModalButtonMessages = 'boost-share-modal-button-messages',
  BoostShareModalButtonPinterest = 'boost-share-modal-button-pinterest',
  BoostShareModalButtonX = 'boost-share-modal-button-x',
  BoostShareModalMobileReady = 'boost-share-modal-mobile-ready',
  BoostShareModalMobileReadyButton = 'boost-share-modal-mobile-ready-button',
  BoostShareModalTitle = 'boost-share-modal-title',
  BoostShareNativeMobileContent = 'boost-share-native-mobile-content',
  BoostShareNativeMobileTitle = 'boost-share-native-mobile-title',
  BoostShortcutEnclosedLean = 'boost-shortcut-enclosed-lean',
  BoostShortcutOpenLean = 'boost-shortcut-open-lean',
  BoostShortcutEnclosedWithStorage = 'boost-shortcut-enclosed-with-storage',
  BoostShortcutGable = 'boost-shortcut-gable',
  BoostShowDetailsButtonLabel = 'boost-show-details-button-label',
  BoostSlidingMenuTitle = 'boost-sliding-menu-title',
  BoostSnackbarWallEditorTip = 'boost-snackbar-wall-editor-tip',
  BoostSnackbarWallEditorTipMobile = 'boost-snackbar-wall-editor-tip-mobile',
  BoostStorageLocation = 'boost-storage-location',
  BoostStorageDepth = 'boost-storage-depth',
  BoostStorageOptions = 'boost-storage-options',
  BoostSupplierDownloadCustomPdf = 'boost-supplier-download-custom-pdf',
  BoostTackRoomAdd = 'boost-tack-room-add',
  BoostTackRoomEdit = 'boost-tack-room-edit',
  BoostTackRoomHeight = 'boost-tack-room-height',
  BoostTackRoomTitle = 'boost-tack-room-title',
  BoostTackRoomWidth = 'boost-tack-room-width',
  BoostThankYouConfirmation = 'boost-thank-you-confirmation',
  BoostThankYouConfirmationOrder = 'boost-thank-you-confirmation-order',
  BoostThankYouDialogTitle = 'boost-thank-you-dialog-title',
  BoostThankYouDialogTitleOrder = 'boost-thank-you-dialog-title-order',
  BoostThankYouExclaimer = 'boost-thank-you-exclaimer',
  BoostThankYouReferenceNumber = 'boost-thank-you-reference-number',
  BoostThankYouRequestHelp = 'boost-thank-you-request-help',
  BoostToolbarBackground = 'boost-toolbar-background',
  BoostToolbarExteriorView = 'boost-toolbar-exterior-view',
  BoostToolbarInteriorView = 'boost-toolbar-interior-view',
  BoostToolbarResetModel = 'boost-toolbar-reset-model',
  BoostToolbarResetView = 'boost-toolbar-reset-view',
  BoostToolbarRotateLeft = 'boost-toolbar-rotate-left',
  BoostToolbarRotateRight = 'boost-toolbar-rotate-right',
  BoostToolbarUndo = 'boost-toolbar-undo',
  BoostToolbarZoomIn = 'boost-toolbar-zoom-in',
  BoostToolbarZoomOut = 'boost-toolbar-zoom-out',
  BoostTooltipDesignRemoved = 'boost-tooltip-design-removed',
  BoostTooltipDesignSaved = 'boost-tooltip-design-saved',
  BoostTutorialButton = 'boost-tutorial-button',
  BoostUpdateButtonLabel = 'boost-update-button-label',
  BoostViewDetailsHeader = 'boost-view-details-header',
  BoostWallOptionFullyEnclosed = 'boost-wall-option-fully-enclosed',
  BoostWallOptionFullyOpen = 'boost-wall-option-fully-open',
  BoostWallOptionOpenExceptStorage = 'boost-wall-option-open-except-storage',
  BoostWallOptionGableEnd = 'boost-wall-option-gable-end',
  BoostWallOptionGableEnds = 'boost-wall-option-gable-ends',
  BoostWallOptionCustom = 'boost-wall-option-custom',
  BoostWallOptionsWalls = 'boost-wall-options-walls',
  BoostWallSelectorLabel = 'boost-wall-selector-label',
}
